import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "goatpelt";

function GIGoatPelt() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIGoatPelt;